/**
 * TotalScoreCard.js
 *
 * Displays the team's total score (Rating / Points / Marks, depending on the library).
 */

import React from "react";
import Card, { CardHeader, CardTitle, CardContent } from "../../../components/ui/Card";

const TotalScoreCard = ({ totalScore, scoreAttribute }) => {
    return (
        <Card className="h-full flex flex-col bg-zinc-900 border-zinc-700 shadow-md">
            <CardHeader className="pb-2">
                <CardTitle className="flex items-center gap-2 text-sm text-zinc-400">
                    Total {scoreAttribute}
                </CardTitle>
            </CardHeader>

            <CardContent className="flex-1 flex items-end justify-end">
                <div className="text-6xl font-extrabold text-yellow">
                    {totalScore}
                </div>
            </CardContent>
        </Card>
    );
};

export default TotalScoreCard;
